/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsSlideshowWithText = {
    init: function($section) {
  
      // Add settings from schema to current object
      Shopify.theme.jsSlideshowWithText = $.extend(this, Shopify.theme.getSectionData($section));
  
      const textTransition = this.text_transition;
  
      // Selectors
      const $imageSlideshowEl = $section.find('[data-image-slideshow]').removeClass('is-hidden');
  
      const $imageSlideshow = $imageSlideshowEl.flickity({
        contain: true,
        wrapAround: true,
        adaptiveHeight: true,
        prevNextButtons: this.show_arrows,
        pageDots: false,
        draggable: true,
        imagesLoaded: true,
        fade: this.image_transition == 'fade' ? true : false,
        autoPlay: this.image_slideshow_speed * 1000,
        arrowShape: arrowShape
      });
  
      $section.find('.flickity-button').wrapAll('<div class="flickity-buttons-container"></div>');
  
    }
  }
  
  /******/ })()
  ;